import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  useToast,
  Box,
  Text,
  Spinner,
} from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../Context/ChatProvider";
import { Ornament, PaletteIcon } from "../ui/Icons";

// Каталог открытых бесед клуба — можно зайти самому
const PublicGroupsModal = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [groups, setGroups] = useState(null);
  const [joining, setJoining] = useState(null);
  const toast = useToast();

  const { user, chats, setChats, setSelectedChat } = ChatState();

  const config = { headers: { Authorization: `Bearer ${user?.token}` } };

  const openAndLoad = async () => {
    onOpen();
    setGroups(null);
    try {
      const { data } = await axios.get("/api/chat/public", config);
      setGroups(data);
    } catch (error) {
      toast({
        title: "Не удалось загрузить беседы",
        status: "error",
        duration: 4000,
        isClosable: true,
        position: "bottom",
      });
      setGroups([]);
    }
  };

  const join = async (group) => {
    try {
      setJoining(group._id);
      const { data } = await axios.put(
        "/api/chat/join",
        { chatId: group._id },
        config
      );
      if (!chats.find((c) => c._id === data._id)) setChats([data, ...chats]);
      setSelectedChat(data);
      toast({
        title: `Вы в беседе «${data.chatName}»!`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "bottom",
      });
      onClose();
    } catch (error) {
      toast({
        title: "Не получилось зайти",
        description: error.response?.data?.message,
        status: "error",
        duration: 4000,
        isClosable: true,
        position: "bottom",
      });
    } finally {
      setJoining(null);
    }
  };

  return (
    <>
      <span onClick={openAndLoad}>{children}</span>

      <Modal onClose={onClose} isOpen={isOpen} isCentered scrollBehavior="inside">
        <ModalOverlay bg="rgba(20, 35, 23, 0.45)" />
        <ModalContent maxH="70vh">
          <ModalHeader
            fontSize="26px"
            fontFamily="'Prata', serif"
            color="#243D27"
            d="flex"
            flexDir="column"
            alignItems="center"
            pb={2}
          >
            Открытые беседы
            <Box mt={2}>
              <Ornament color="#8D414B" opacity={0.55} width={110} />
            </Box>
          </ModalHeader>
          <ModalCloseButton borderRadius="10px" />
          <ModalBody pb={5}>
            {!groups ? (
              <Spinner color="#8D414B" size="lg" d="block" mx="auto" my={8} />
            ) : groups.length === 0 ? (
              <Text
                textAlign="center"
                color="rgba(36, 61, 39, 0.6)"
                fontSize="sm"
                py={6}
              >
                Пока нет открытых бесед, в которых вас нет.
                <br />
                Создайте свою — кнопка «Новая»!
              </Text>
            ) : (
              groups.map((g) => (
                <Box
                  key={g._id}
                  d="flex"
                  alignItems="center"
                  bg="#F6E8C6"
                  border="1px solid #E4D2A6"
                  borderRadius="14px"
                  px={3}
                  py={2.5}
                  mb={2}
                >
                  <Box
                    w="38px"
                    h="38px"
                    minW="38px"
                    borderRadius="full"
                    bg="#243D27"
                    d="flex"
                    alignItems="center"
                    justifyContent="center"
                    mr={3}
                  >
                    <PaletteIcon size={20} color="#F2DFB6" />
                  </Box>
                  <Box flex="1" minW={0}>
                    <Text fontWeight={500} isTruncated>
                      {g.chatName}
                    </Text>
                    <Text fontSize="xs" opacity={0.7} isTruncated>
                      участников: {g.users.length}
                      {g.groupAdmin ? ` · создатель: ${g.groupAdmin.name}` : ""}
                    </Text>
                  </Box>
                  <Button
                    size="sm"
                    colorScheme="burgundy"
                    borderRadius="10px"
                    ml={2}
                    isLoading={joining === g._id}
                    onClick={() => join(g)}
                    _hover={{ bg: "#7A3841" }}
                  >
                    Зайти
                  </Button>
                </Box>
              ))
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PublicGroupsModal;
